<template>
	<div class="user-dialog scrollable">
		<div class="user-info">
			<UserPicture class="picture" :src="'https://ui-avatars.com/api/?name=' + user.first_name + '+' + user.last_name + '&size=64'"/>

			<div>
				<div class="name">{{ [user.first_name, user.last_name].join(' ') }}</div>
				<div class="email">{{ user.email }}</div>
			</div>

		</div>

		<div class="manage-actions">
			<!-- Link per vedere le iscrizioni -->
			<button class="subscriptions-button" @click="goToSubscriptions">
				📅 Vedi iscrizioni alle Small Class
			</button>

		</div>

		<div class="membership">
			<label>
				<input type="checkbox" :checked="user.membership" @click.prevent="toggleMembership"/>
				Enable membership
			</label>
		</div>

		<div class="add-product-panel">
			<form class="form" @submit.prevent="addProduct">
				<div class="fields">
					<input class="name" v-model="product.name" type="text" placeholder="Name"/>
					<input class="size" v-model="product.size" type="number" size="2" placeholder="20"/>

                    <!-- ✅ Campo data -->
                    <input v-if="parseInt(product.size) === 0"
                        class="expire" 
                        v-model="product.expire_date" 
                        type="date" 
                        placeholder="Scadenza (solo abbonamenti)"/>
				</div>

				<button class="add-product-button" type="submit">Product</button>
			</form>
		</div>

		<div class="products">
			<div v-for="prod in products" :key="prod.id" class="product" :class="productClasses(prod)">
				<div class="info">
					<div class="name">
						<div>
							{{ prod.name }}
							<button class="fas fa-trash" @click="removeProduct(prod)"></button>
						</div>

						<div v-if="prod.size === 0 && isExpired(prod.expire_date)" class="badge badge-expired">Scaduto</div>
						<div v-else-if="prod.size === 0 && isExpiring(prod.expire_date)" class="badge">In Scadenza</div>
					</div>

					<div class="charges">
						<template v-if="prod.size > 0">
							<div class="remaining">{{ prod.remaining || '-' }}</div>
							<div class="size">/{{ prod.size }}</div>
							<div class="actions">
								<button class="take" @click="useProduct(prod, 1)"></button>
								<button class="give" @click="useProduct(prod, -1)"></button>
							</div>
						</template>

						<template v-else-if="prod.expire_date">
							<div class="expiration">Scade il: {{ formatDate(prod.expire_date) }}</div>
						</template>
					</div>
				</div>
			</div>
		</div>

		<div class="manage-actions deleteuser">
			<button class="delete" @click="deleteUser">Delete User</button>
		</div>

	</div>
</template>

<script>
import api from '@/api'
import { notif } from '@/pop'

export default {
	name: 'UserDialog',

	props: {
		/// User data
		user: {
			type: Object,
			required: true
		}
	},

	data() {

		return {
			product: {
				name: '',
				size: 20,
                expire_date: '' // 👈 aggiunto
			},

			// List of products
			products: [],
			usedProductIds: new Set() // 👈 Pacchetti usati nelle prenotazioni future
		}
	},

	methods: {
		goToSubscriptions() {
			this.$emit('close'); // chiude la dialog
			this.$router.push({
				path: `/admin/users/${this.user.id}/subscriptions`,
				query: { name: this.user.first_name + ' ' + this.user.last_name }
			});
		},
		isExpiring(expirationDate) {
			if (!expirationDate) return false;
			const today = new Date();
			const expDate = new Date(expirationDate);
			const diffTime = expDate - today;
			const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
			return diffDays <= 7;
		},
		isExpired(expirationDate) {
			if (!expirationDate) return false;
			const today = new Date().setHours(0, 0, 0, 0);
			const exp = new Date(expirationDate).setHours(0, 0, 0, 0);
			return exp <= today;
		},
		productClasses(prod) {
			const isUsed = this.usedProductIds.has(prod.id);

			if (prod.size === 0) {
				return {
					subscription: true,
					expiring: this.isExpiring(prod.expire_date),
					expiredSub: this.isExpired(prod.expire_date),
					used: isUsed // ✅ pacchetto usato in lezioni future
				};
			}

			return {
				expired: prod.remaining <= 0,
				used: isUsed // ✅ anche i pacchetti normali possono essere "usati"
			};
		},

		formatDate(isoString) {
			const d = new Date(isoString)
			return d.toLocaleDateString('it-IT', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric'
			})
			},
		/**
		 * 
		 */
		async fetchProducts() {
			try {
				// Carica i prodotti
				const products = await api.user().getProducts(this.user.id);
				this.products = products;

				// Trova lunedì della settimana corrente
				const today = new Date();
				const day = today.getDay(); // 0 (dom) - 6 (sab)
				const monday = new Date(today);
				monday.setDate(today.getDate() - ((day + 6) % 7)); // lunedì

				// Trova domenica della prossima settimana
				const sundayNext = new Date(monday);
				sundayNext.setDate(monday.getDate() + 13); // domenica successiva

				const from_date = monday.toISOString().split('T')[0];
				const to_date = sundayNext.toISOString().split('T')[0];

				// Recupera prenotazioni nel range
				const subscriptions = await api.user().getSubscriptions(this.user.id, { from_date, to_date });

				// Estrai ID pacchetti usati
				const usedIds = new Set(
					subscriptions
						.filter(sub => sub.product !== null)
						.map(sub => sub.product)
				);

				this.usedProductIds = usedIds;

			} catch (err) {
				console.error(err);
				notif.error('Impossibile caricare la lista di pacchetti');
			}
		},

		/**
		 * 
		 */
        async addProduct() {
            try {
                let product = await api.admin().addProduct(this.user.id, this.product)
                this.products.push(product)
            } catch (err) {
                console.error(err)
                notif.error('Errore, riprova più tardi')
            }
        },

		/**
		 * 
		 */
		async removeProduct(prod) {
			try {
				const conferma = confirm(`Sei sicuro di voler cancellare il pacchetto "${prod.name}"?`);
				if (!conferma) return;

				await api.admin().removeProduct(this.user.id, prod.id);
				let idx = this.products.findIndex((other) => other.id === prod.id);
				this.$delete(this.products, idx);
				notif.done(`${prod.name} è stato rimosso`);
			}
			catch (err) {
				console.error(err);
				notif.error('Errore durante la rimozione del pacchetto');
			}
		},

		/**
		 * 
		 */
		async deleteUser() {
			try {
				const conferma = confirm(`Sei sicuro di voler eliminare l'utente "${this.user.first_name} ${this.user.last_name}"? Questa operazione non può essere annullata.`);
				if (!conferma) return;

				await api.admin().deleteUser(this.user.id);
				notif.done('Utente eliminato');
				this.$emit('delete');
			}
			catch (err) {
				console.error(err);
				notif.error('Errore, riprova più tardi');
			}
		},

		/**
		 * 
		 */
		async toggleMembership() {

			try
			{
				await api.admin().toggleMembership(this.user.id, !this.user.membership)
				notif.done(this.user.membership ? 'Membership revocata' : 'Membership aggiunta')

				this.$emit('membership')
			}
			catch (err)
			{
				console.error(err)
				notif.error('Errore, riprova più tardi')
			}
		},

		/**
		 * 
		 */
		async useProduct(prod, uses = 1) {

			try
			{
				// Find product
				const idx = this.products.findIndex(({ id }) => id === prod.id)

				if (idx !== -1)
				{
					// Show local changes first
					prod.personal += uses
					prod.remaining -= uses

					// Use product
					this.products.splice(idx, 1, await api.admin().useProduct(this.user.id, prod.id, uses))

					// TODO: Potential consistency problem with slow connections
					// A simple fix: debounce uses and send single request at the end
				}
				else console.warn('Product does not exists')
			}
			catch (err)
			{
				console.error(err.dev_msg || String(err))
				notif.error('Errore, riprova più tardi')
			}
		}
	},

	mounted() {

		// Load product list
		this.fetchProducts()
	}
}
</script>

<style lang="stylus" scoped>
.subscriptions-button
	display block
	text-align center
	background-color #ffe010
	color #232b34
	font-weight bold
	padding 0.8em 1em
	margin-top 1em
	border none
	text-decoration none
	cursor pointer
	transition background-color 0.2s ease

	&:hover
		background-color #d4ac0d

.user-dialog
	display grid
	grid-template-columns auto
	grid-gap 1em

	.user-info
		display grid
		grid-template-columns auto 1fr
		align-items center
		grid-gap 1em

		.picture
			width 96px
			height 96px
		
		.name
			color secondary

			font-size 1.2em
			font-weight bold
		
		.email
			color lightish

			font-size 0.9em
			font-style italic
	
	.manage-actions
		display grid
		grid-template-columns auto
		grid-gap 1em

		button
			padding 0.6em
			border none

			font-size 1em
			font-weight bold

			cursor pointer

			&:before
				margin-right 0.5em

				font-family 'Font Awesome 5 Free'
				font-weight bold
			
			&:focus
				outline none
				border none
			
			&.delete
				background-color crimson
				color light

				&:before
					content '\f503'
	.deleteuser
		margin-top 1.5em
		margin-bottom 1em
	
	.add-product-panel
		border 1px solid darkish
		padding 1.5em
		margin-top 2em

		.fields
			display grid
			grid-template-columns 1fr auto
			grid-gap 1em

			input
				padding 0.6em
				border none

				color light
				background-color darkish

				font-family fontSans
				font-size 1em

		.expire
			color light
			background-color darkish
			padding 0.6em
			border none
			font-family fontSans
			font-size 1em
			font-style: italic
			margin-top: 0.3em

		.add-product-button
			float right

			margin-top 1em
			padding 0.6em 0.8em
			border none

			color darkish
			background-color primary

			font-size 1em
			font-weight bold

			cursor pointer

			&:before
				content '\f067'

				margin-right 0.5em

				font-family 'Font Awesome 5 Free'
				font-weight 900
	
	.products
		display grid
		grid-template-columns auto
		grid-gap 1em

		margin-top 2em

		.product
			padding 1em
			border-radius 0.5em

			background-color darker

			cursor pointer

			.info
				display grid
				grid-template-columns 1fr auto
				align-items center

				.name
					color light

					font-size 1.4em
					font-weight bold
				
				.charges
					padding 1em
					border-left 2px solid secondary

					text-align center

					.remaining
						color secondary

						font-size 2em
						font-weight bold
						
					.actions
						display grid
						grid-template-columns 1fr 1fr
						grid-gap 1em

						margin-top 1em

						.take
						.give
							display block

							padding 0.4em 0.6em
							border none
							border-radius 0.4em
							outline none

							background-color primary
							color darkish

							font-size 0.9em

							cursor pointer

							transition transform 0.1s ease-in-out

							&:before
								display inline-block

								font-family 'Font Awesome 5 Free'
								font-weight 900
							&:hover
								transform scale(1.1)
							&:focus
								border none
								outline none
						
						.take
							background-color indianred
							color light

							&:before
								content '\f068'

						.give
							background-color light


							&:before
								content '\f067'
			
			&.selected
				box-shadow 0 0 0 2px primary

				.name
					color primary

.product.subscription
	border 2px solid #00bcd4
	color light
	min-height 70px

	.name
		color light

	.charges
		border-left 2px solid #00bcd4

.product.expiring
	border 2px dashed #ffe010
	color light

	.name
		color orange

	.charges
		border-left 2px dashed #ffe010

.product.expiredSub
	border 2px solid crimson
	color mix(light, dark, 50%)

	.name
		color inherit

	.charges
		border-left 2px solid crimson

.badge
	background-color #ffe010
	color dark
	padding 0.2em 0.5em
	margin-top 0.5em
	border-radius 0.5em
	font-size 0.8em
	font-weight bold
	text-align center
	display inline-block

.badge-expired
	background-color crimson
	color light
	padding 0.2em 0.5em
	margin-top 0.5em
	border-radius 0.5em
	font-size 0.8em
	font-weight bold
	text-align center
	display inline-block

.scrollable
	max-height 90vh
	overflow-y auto
	padding-right 1em

.product.used
	box-shadow: 0 0 0 2px #8886
	background-color rgba(255, 255, 255, 0.05)

	.name::after
		content ' • in uso'
		font-size 0.7em
		color secondary
		margin-left 0.5em

</style>
